import React from 'react'
import {
  Box,
  Button,
  Heading,
  Text,
  VStack,
  useColorModeValue,
  Alert,
  AlertIcon,
  AlertDescription,
} from '@chakra-ui/react'
import { FaSignature } from 'react-icons/fa'

interface SignMessageFormProps {
  onSign: () => Promise<boolean>
  isLoading: boolean
  error: string | null
}

const SignMessageForm: React.FC<SignMessageFormProps> = ({
  onSign,
  isLoading,
  error,
}) => {
  const bgColor = useColorModeValue('white', 'gray.700')
  const timestamp = Math.floor(Date.now() / 1000)

  return (
    <Box
      p={6}
      bg={bgColor}
      borderRadius="md"
      boxShadow="md"
      maxW="md"
      width="100%"
    >
      <VStack spacing={4} align="stretch">
        <Heading size="md">Sign Message to Authenticate</Heading>

        <Text fontSize="sm" color="gray.500">
          For security purposes, please sign the message to verify your wallet
          ownership.
        </Text>

        <Box p={4} bg="gray.50" borderRadius="md">
          <Text fontSize="sm" fontWeight="bold">
            Message to sign:
          </Text>
          <Text fontSize="sm" mt={2} fontFamily="monospace">
            {timestamp}
          </Text>
        </Box>

        {error && (
          <Alert status="error" borderRadius="md">
            <AlertIcon />
            <AlertDescription>{error}</AlertDescription>
          </Alert>
        )}

        <Button
          leftIcon={<FaSignature />}
          colorScheme="blue"
          isLoading={isLoading}
          loadingText="Signing..."
          onClick={onSign}
        >
          Sign & Authenticate
        </Button>
      </VStack>
    </Box>
  )
}

export default SignMessageForm
